import Vue from 'vue'
import store from 'store'

import { mapActions } from 'vuex'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

export default (el) =>
  Promise.all([
    enqueueModule('product-card.vue'),
    enqueueModule('product-card-slider.vue'),
    enqueueModule('vue-image.vue'),
    enqueueModule('vue-image-small.vue'),
    enqueueModule('quick-view.vue'),
    enqueueModule('dropdown-menu.vue'),
    enqueueModule('quantity-selector.vue'),
    enqueueModule('modal.vue')
  ]).then(
    () =>
      new Vue({
        el,
        store,
        data () {
          return {}
        },
        methods: {
          ...mapActions('global', ['openModal'])
        }
      })
  )
